import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PharmacyInfo } from '../models/index';
import { Api, Session } from '../services/index';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import {TranslateService} from '@ngx-translate/core'; 


@Component({
  selector: 'app-exam-reason',
  templateUrl: './exam-select-pharmacy.html',
  styleUrls: ['exam-select-pharmacy.css'],
})

export class ExamSelectPharmacy implements OnInit {
  // @ViewChild('myModal') _modalSearch: ElementRef;
  @ViewChild('modalDialog') public modalDialog: DialogComponent;
  public target: string = "#targetModal";
  public width: string = '95%';
  public height: string = '100%';
  public header: string = 'Search Pharmacy';
  // Initialize Button to open the modal Dialog
  // public buttons: Object[] = [{ click: this.dlgButtonClick, buttonModel: { content: 'Close', cssClass: 'e-flat', isPrimary: true } }];
  public isModal: Boolean = true;
  public animationSettings: Object = { effect: 'None' };
  public hide: any;
  position: object = { X: 'top', Y: 'center' };
  public dialogdragging: Boolean = true;
  public showCloseIcon: Boolean = true;
  public dialogResize: Boolean = true;

  loading:boolean = false;
  hasNoResults: boolean = false;
  patientId: number;
  preferredPharmacyList: PharmacyInfo[] = [];
  pharmacySearchResults: Array<any>; 
  searching: boolean = false;
  searchText: string = '';

  modalBtnClick() {
   
      this.modalDialog.show(); 
    }
  
    // Close the Dialog, while clicking "OK" Button of Dialog
    public dlgButtonClick: EmitType<Object> = () => {
      this.searchText = '';
      this.pharmacySearchResults = null;
      this.hide();      
    }
   
    public dialogClose: EmitType<Object> = () => {
      this.searchText = '';
      this.pharmacySearchResults = null;
      this.modalDialog.visible = false;
  }
  
    // Close the modal Dialog on overlay click
    public overlayClick(): void {
      this.searchText = '';
      this.pharmacySearchResults = null;
      this.modalDialog.hide();
  
    }

  constructor(private api: Api, 
              private route: ActivatedRoute,
              private changeDetectorRef: ChangeDetectorRef,
              private router: Router,
              private session: Session,
              private translateService: TranslateService,
              private sanitizer: DomSanitizer) {
    this.patientId = this.route.snapshot.params['patientId'] || ''; 
    
    let pharmacies = this.api.getPreferredPharmacyList(this.patientId);
    pharmacies.subscribe(response => {
      
  
      this.preferredPharmacyList = response;
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
    })
  }

  ngOnInit() {
    this.translateService.get('SEARCH_PHARMACY.SEARCH_PHARMACY_TITLE').subscribe((res: string) => {
      if(res){
        this.header  = res;
      }else{
        this.header  = 'Search Pharmacy';
      }
      
      console.log(res);
    });  


  }

  ngAfterViewInit(): void {
    document.getElementById('modalbtn').focus();
}




  getIntakeLOB(){
    return this.session.intakeLob;
  }

  trim(value) {
    return value.trim();
  }

	cleanURL(oldURL : string): SafeResourceUrl{
	
		return this.sanitizer.bypassSecurityTrustUrl(oldURL);

	}
  skipPharmacy() {
    this.router.navigate(['exam-have-allergies/' + this.patientId]);
  }
  
  navigateToPharmacy(pharmLocation){
    console.log('navigateToPharmacy:', pharmLocation);
    let url =  'https://www.google.com/maps/search/?q=' + pharmLocation.address1 + ', ' + pharmLocation.city + ', ' + pharmLocation.state;
    window.open(url, "_blank");
  }
 


  searchPharmacy() {
    try {
      if (this.searchText.trim().length > 4) {
        this.pharmacySearchResults = [];
        this.searching = true;
        this.hasNoResults = false;
        let searchParms = { 'Street': this.searchText.trim() }
        this.api.searchPharmacy(200, 1000, searchParms).subscribe((result: any) => {
          this.pharmacySearchResults = result;
          this.searching = false;
          if (this.pharmacySearchResults.length ===  0 ) {
            this.hasNoResults = true;
          }
        },
          err => {
            console.log(err)
            this.searching = false;
            this.hasNoResults = true;
          })
      } else {
        this.searching = false;
      }
    }
    catch (Error) {
      console.log("Error in SearchChanged: " + Error);
      this.searching = false;
    }
  }

  savePharmacy(item) {
    this.loading = true;
    this.api.updateIntakePharmacy(this.session.serverIntake.intakeId, item.id).subscribe(result => {
      this.searchText = '';
      this.session.clientIntake.pharmacy = item;
      this.loading = false;
      this.router.navigate(['exam-have-allergies/' + this.patientId]);
    }, ex => {
      this.loading = false 
    });
  }
}
